import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/cmore/ellipse_left.png";
import { StaticImage } from "gatsby-plugin-image";

const Ideacmore = () => {
  return (
    <div
      className="idea_cmore p-100"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#000" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Project <span>Idea</span>
            </h2>
            <strong>Goals set for TekRevol</strong>
            <p>
              The primary goal behind CMORE is to build a technologically
              advanced and tailored e-commerce solution that specifically meets
              the unique needs of construction material stores and builders.
              Streamline and enhance procurement processes to create a
              user-friendly platform, simplifying the entire journey from
              product discovery to order placement and delivery. Ensure
              operational efficiency by embracing technological innovations and
              best practices, aiming to provide a cutting-edge solution that
              advances the construction commerce sector.
            </p>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="idea_img">
              <StaticImage
                src="../../../images/case-studies/cmore/idea.png"
                alt="TekRevol"
                className="img-fluid d-none d-md-block"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={955}
              />
              <StaticImage
                src="../../../images/case-studies/cmore/idea_mob.png"
                alt="TekRevol"
                className="img-fluid d-sm-block d-md-none"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={821}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ideacmore;
